<template>
  <div class="flex flex-wrap uploadGoogleImg">
    <el-upload
      list-type="picture-card"
      ref="upload"
      class="mr-2 mb-4"
      v-bind="defaultParams"
      :file-list="videoList"
      :auto-upload="false"
      v-show="videoList.length < defaultParams.limit"
    >
      <div class="leading-4 text-xs border w-full h-full flex flex-col justify-center items-center rounded-md p-4">
        <div class="mb-2">
          <el-button
            type="primary"
            size="medium"
            @click.stop="openYouTube"
            >youtube选择</el-button
          >
        </div>
        <div class="mb-2">
          <el-button
            type="primary"
            size="medium"
            @click.stop="addVideoByUrlClick"
            >youtube链接</el-button
          >
        </div>
        <el-button
          type="primary"
          size="medium"
          @click.stop="uploadYouTube"
          >点击上传</el-button
        >
        <div class="text-gray-700 leading-6 mt-1">
          <div>横向视频：16:9</div>
          <div>方形视频：1:1</div>
          <div>纵向视频：9:16</div>
          <div>格式为MP4</div>
        </div>
      </div>
    </el-upload>
    <div
      v-for="(file, index) in videoList"
      :key="file.uid"
      class="mr-4 mb-4 w-[160px] flex flex-col"
    >
      <div class="relative w-full h-[240px] leading-none border-[1px] box-border border-dashed divide-inherit border-[#f2f2f2]">
        <youtube
          class="w-full h-full"
          :video-id="file.videoId"
          v-bind="params"
          v-if="file.type === 'youtube' || file.videoId"
        ></youtube>
        <video
          class="w-full h-full block"
          :src="file.ossFileUrl"
          :poster="file.thUrl"
          controls
          v-else
        ></video>
        <div
          class="w-full"
          v-if="file.status === 'processing'"
        >
          <el-progress
            :stroke-width="10"
            :percentage="Math.min(file.process, 100)"
          ></el-progress>
        </div>
        <!-- 删除 -->
        <div
          class="absolute -right-2 -top-2 w-6 h-6 leading-none cursor-pointer z-20"
          v-if="!disabled"
        >
          <i
            class="el-icon-circle-close hover:text-primary text-[24px]"
            @click.stop="deleteItem(index)"
          ></i>
        </div>
        <!-- 重新上传 -->
        <div
          class="z-10 absolute left-0 top-0 w-full h-full bg-white bg-opacity-75 bottom-0 right-0 m-auto flex flex-col justify-center items-center"
          v-if="file.process === -1"
        >
          <div class="text-red-600 mt-3 text-base">
            <i class="el-icon-warning !text-red-600 !text-base"></i> {{ file.uploadFailedReason || '上传失败' }}
          </div>
          <el-button
            size="mini"
            type="primary"
            @click.stop="uploadFile(file)"
            >重新上传</el-button
          >
        </div>
        <div
          class="z-10 absolute left-0 top-0 w-full h-full bg-white bg-opacity-75 bottom-0 right-0 m-auto flex flex-col justify-center items-center"
          v-if="(file.status === 'failed' && file.process == 100) || file.status === 'failed'"
        >
          <div class="text-red-600 mt-3 text-base">
            <i class="el-icon-warning !text-red-600 !text-base"></i> {{ file.failReason }}
          </div>
        </div>
        <!-- 重新上传封面 -->
        <div
          class="absolute bottom-1 left-0 w-full text-center z-10"
          v-if="[100, 150, 200].includes(file.process)"
        >
          <el-button
            type="text"
            size="mini"
            :loading="file.coverUploading"
            @click.stop="handleUploadCover(index)"
          >
            重新上传封面
          </el-button>
        </div>
      </div>
      <!-- AI 视频标记 -->
      <div
        class="text-center mt-1"
        v-if="file.fileId"
      >
        <ai-usage-tag
          :file-id="file.fileId"
          :value="file.ai_tag"
          :disabled="file.status !== 'succeeded'"
          @change="val => handleAiTagChange(val, index)"
        />
      </div>
    </div>
    <!-- 本地上传视频到youtube -->
    <UploadVideoYoutube
      :limit="defaultParams.limit"
      :saveAdFileParam="saveAdFileParam"
      :adMaterialParams="adMaterialParams"
      :upload-video-youtube-show.sync="uploadVideoYoutubeShow"
      @updateValue="(list) => setValue(list, 'upload')"
    />
    <!-- 从youtube 选择视频 -->
    <YoutubeVideos
      :select-youtube-video-show.sync="selectYoutubeVideoShow"
      @updateValue="(list) => setValue(list, 'youtube')"
    />
    <!-- 通过youtubeUrl 添加视频 -->
    <AddVideoByUrl
      :addVideoByUrlShow.sync="addVideoByUrlShow"
      @getVideoList="setValue"
    />
    <!-- 隐藏的封面图片选择 input -->
    <input
      ref="coverInput"
      type="file"
      accept="image/png,image/jpeg,image/jpg,image/gif"
      style="display: none"
      @change="handleCoverFileChange"
    />
  </div>
</template>

<script>
import UploadVideoYoutube from '@/views/google/components/UploadVideoYoutube/index.vue';
import YoutubeVideos from '@/views/google/components/YoutubeVideos/index.vue';
import AddVideoByUrl from '@/views/google/create/components/creatives/AddVideoByUrl/index.vue';
import { objectDeepEqual } from '@/utils/utils';
import { getVideoProcess, syncUploadVideo, updateVideoCoverImage } from '@/api/google/youtube';
import { uploadImg } from '@/api/common.js';
import { getOptLogId, formatterName } from '../index';
import { AiUsageTag } from '@adCommonComponent';
const statusList = [
  { key: 'failed', label: '视频处理失败' },
  { key: 'processing', label: '视频当前正在处理中' },
  { key: 'succeeded', label: '视频已成功处理' },
  { key: 'terminated', label: '处理信息不再可用' },
  { key: 'unknown', label: '未知' },
];
export default {
  components: { UploadVideoYoutube, YoutubeVideos, AddVideoByUrl, AiUsageTag },
  props: {
    value: { type: Array, default: () => [] },
    data: { type: Object, default: () => ({}) },
    creative: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    currentAccount: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      //上传upload 参数
      defaultParams: {
        limit: 5,
        action: '#',
        accept: '.mp4',
        multiple: true,
        'show-file-list': false,
        'list-type': 'picture-card',
      },
      uploadVideoYoutubeShow: false, //上传视频到youtube弹窗
      selectYoutubeVideoShow: false, //从youtube选择视频
      processMap: {}, //查询进度的map 数据
      params: {
        'player-width': 160,
        'player-height': 240,
      },
      timer: null,
      addVideoByUrlShow: false,
      coverUploadIndex: -1, // 当前正在上传封面的视频索引
    };
  },
  computed: {
    videoList: {
      //当前视频列表
      get() {
        return this.value;
      },
      set() {},
    },
    userInfo() {
      return this.$store.state.user.userInfo.data;
    },

    saveAdFileParam() {
      return {
        initiatorUid: this.userInfo.id,
        uid: this.userInfo.id,
        orgCode: this.userInfo.orgCode,
        saleId: this.data.promoteInfo?.sale?.saleId || this.value.promoteInfo?.sale?.saleId || 0, //创建|复制、批量编辑|
        langId: this.data.promoteInfo?.site?.langId || this.value.promoteInfo?.site?.langId || 0,
        proId: this.data.promoteInfo?.sale?.productId || this.value.promoteInfo?.sale?.productId || 0,
        adAccountId: this.currentAccount.id,
      };
    },
    adMaterialParams() {
      return {
        mediaType: 'VIDEO',
        platform: 'google',
        productId: this.data.promoteInfo?.sale?.productId || this.value.promoteInfo?.sale?.productId,
        aid: this.currentAccount.id,
        adid: this.creative?.adGroupAdId || '', //复制的时候没有,创建的时候没有
        lpu: this.creative?.finalUrl || '',
      };
    },
  },
  watch: {
    value() {
      console.log('VALUEcHANGE');
      console.log(this.value);
    },
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    /**
     * 更新视频数组
     */
    updateValue(list) {
      this.$emit('input', list.slice(0, this.defaultParams.limit));
    },
    /**
     * AI 视频标记变更
     */
    handleAiTagChange(val, index) {
      const list = [...this.videoList];
      list[index] = { ...list[index], ai_tag: val };
      this.updateValue(list);
    },
    /**
     * 获取本地上传的视频数组
     */
    setValue(list, type) {
      list = list.slice(0, this.defaultParams.limit);
      list.forEach(async (video) => {
        // 这里只处理从youtube 选择的，是本地上传还是个人素材库选择需要从UploadVideoYoutube组件中区分
        try {
          getOptLogId({
            adAccountId: this.currentAccount.id,
            mediaType: 'VIDEO',
            fileId: video.fileId,
            sourceType: 'ONLINE_LIB',
          });
        } catch {}
        video.type = type;
        // 本地上传
        if (type === 'upload') {
          video.process = 0;
          video.status = 'processing';
          this.onChange(video);
        } else if (type === 'getByUrl') {
          video.process = 100;
          video.status = 'succeeded';
          video.type = 'getByUrl';
          video.videoName = formatterName(video.videoName);
        } else {
          //youtube 选择
          video.process = 100;
          video.status = 'succeeded';
          video.videoName = formatterName(video.videoName);
        }
      });
      let listAll = this.videoList.concat(list);
      console.log(list);
      this.updateValue(listAll);
    },
    /**
     * 上传视频到youtube
     */
    uploadYouTube() {
      this.uploadVideoYoutubeShow = true;
    },
    /**
     * 打开YouTube
     */
    openYouTube() {
      //   this.$emit('openYouTube');
      this.selectYoutubeVideoShow = true;
    },
    /**
     * 通过url上传视频
     */
    addVideoByUrlClick() {
      this.addVideoByUrlShow = true;
    },
    /**
     * 删除视频
     */
    deleteItem(index) {
      this.videoList.splice(index, 1);
      //   console.log(this.videoList, 'this.videoList');
      this.updateValue(this.videoList);
    },

    /**
     * 触发change 事件
     */
    onChange(file) {
      console.log(
        file,
        'change',
        this.videoList.length,
        this.defaultParams.limit,
        this.videoList.length >= this.defaultParams.limit,
      );
      if (this.videoList.length >= this.defaultParams.limit) return;
      this.uploadFile(file);
      //   this.getProgress();
    },
    /**
     * 上传进度条
     */
    getProgress() {
      clearTimeout(this.timer);
      const ids = this.videoList
        .filter((v) => v.processId && v.process !== -1 && v.status === 'processing')
        .map((item) => item.processId);
      console.log(ids);
      if (!ids.length) {
        return;
      }
      getVideoProcess({ recordIds: ids.join(','), searchStatus: true })
        .then((res) => {
          if (res.code === 0) {
            res.data.forEach((item) => {
              item.status = item.processingStatus;
              this.processMap[item.recordId] = { ...item };
              let obj = {
                ...item,
                status: item.processingStatus || 'processing',
                failReason: item.processingFailureReason || '',
                uploadFailedReason: item.failReason,
              };
              const index = this.videoList.findIndex((v) => v.processId === item.recordId);
              this.videoList[index] = { ...this.videoList[index], ...obj, ...obj.video };
            });
            this.updateValue(this.videoList);
            this.timer = setTimeout(() => {
              this.getProgress();
            }, 5000);
          }
        })
        .catch((res) => {
          console.log(res, 'failreson 500');
          ids.forEach((item) => {
            const index = this.videoList.findIndex((v = v.recordId == item));
            this.videoList[index] = { ...this.videoList[index], process: 0, status: 'failed' };
            this.updateValue(this.videoList);
          });
        });
    },
    /**
     * 上传图片到YouTube
     */
    uploadFile(data) {
      console.log(data);
      syncUploadVideo(data)
        .then((res) => {
          const list = this.videoList;
          const index = list.findIndex((item) => item.uid === data.uid);
          if (res.code === 0) {
            list[index] = { ...list[index], processId: res.data, status: 'processing', process: 0 };
            this.getProgress();
          } else {
            list[index] = { ...list[index], status: 'failed', process: 0, failReason: res.comment };
          }
          this.updateValue(list);
        })
        .catch(() => {
          const list = this.videoList;
          const index = list.findIndex((item) => item.fileId === data.fileId);
          list[index] = { ...list[index], status: 'failed', process: 0 };
          this.updateValue(list);
        });
    },
    /**
     * 触发封面上传文件选择
     * @param {number} index - 视频在 videoList 中的索引
     */
    handleUploadCover(index) {
      this.coverUploadIndex = index;
      this.$refs.coverInput.click();
    },
    /**
     * 校验封面图片文件（大小、格式、分辨率、比例）
     * @param {File} file - 图片文件
     * @returns {Promise<void>} 校验通过 resolve，失败 reject(错误信息)
     */
    validateCoverImage(file) {
      return new Promise((resolve, reject) => {
        // 格式校验
        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        if (!allowedTypes.includes(file.type)) {
          return reject('仅支持 JPG、JPEG、PNG、GIF 格式的图片');
        }
        // 大小校验：不超过 2MB
        if (file.size / 1024 / 1024 > 2) {
          return reject('图片文件不得超过 2MB');
        }
        // 分辨率和比例校验
        const img = new Image();
        img.onload = () => {
          URL.revokeObjectURL(img.src);
          const { width, height } = img;
          // 最小宽度 640px
          if (width < 640) {
            return reject('图片宽度不能小于 640 像素');
          }
          // 推荐 16:9 比例，允许 5% 误差
          const ratio = width / height;
          const target = 16 / 9;
          if (Math.abs(ratio - target) / target > 0.05) {
            return reject('图片比例建议为 16:9（推荐分辨率 1280x720）');
          }
          resolve();
        };
        img.onerror = () => {
          URL.revokeObjectURL(img.src);
          reject('图片加载失败，请重新选择');
        };
        img.src = URL.createObjectURL(file);
      });
    },
    /**
     * 处理封面图片文件选择后的上传逻辑
     * @param {Event} event - input change 事件
     */
    async handleCoverFileChange(event) {
      const selectedFile = event.target.files[0];
      if (!selectedFile) return;
      const file = this.videoList[this.coverUploadIndex];
      if (!file) return;
      // 校验封面图片
      try {
        await this.validateCoverImage(selectedFile);
      } catch (err) {
        this.$message.warning(err);
        this.$refs.coverInput.value = '';
        return;
      }
      // 校验是否有频道凭证信息
      if (!file.youtubeCredentialId) {
        this.$message.warning('缺少频道凭证信息，无法更新封面');
        this.$refs.coverInput.value = '';
        return;
      }
      this.$set(file, 'coverUploading', true);
      try {
        // 上传图片获取 URL
        const uploadRes = await uploadImg({ file: selectedFile });
        const url = uploadRes.data.url;
        // 调用更新封面接口
        const res = await updateVideoCoverImage({
          youtubeChannelId: file.youtubeChannelId,
          youtubeCredentialId: file.youtubeCredentialId,
          videoId: file.videoId,
          customCoverImage: url,
        });
        if (res.code === 0) {
          this.$message.success('封面更新成功');
          this.$set(file, 'thUrl', url);
        } else {
          this.$message.error(res.comment || '封面更新失败');
        }
      } catch {
        this.$message.error('封面更新失败');
      } finally {
        this.$set(file, 'coverUploading', false);
        this.$refs.coverInput.value = '';
      }
    },
  },
};
</script>
<style lang="scss">
.uploadGoogleImg {
  .el-upload--picture-card {
    width: 160px;
    height: 240px;
  }
}
</style>
